import general from "@/plugins/i18n/en/general"
import auth from "@/plugins/i18n/en/auth"
import nav from "@/plugins/i18n/en/nav"
import audit from "@/plugins/i18n/en/audit"
import dashboard from "@/plugins/i18n/en/dashboard"
import employee from "@/plugins/i18n/en/employee"
import validation from "@/plugins/i18n/en/validation"
import category from "@/plugins/i18n/en/category"
import additionaleffort from "@/plugins/i18n/en/additionaleffort"
import material from "@/plugins/i18n/en/material"
import machine from "@/plugins/i18n/en/machine"
import customer from "@/plugins/i18n/en/customer"
import project from "@/plugins/i18n/en/project"
import settings from "@/plugins/i18n/en/settings"
import packet from "@/plugins/i18n/en/packet"
import userposition from "@/plugins/i18n/en/userposition"
import hourlywagereport from "@/plugins/i18n/en/hourlywagereport"
import hourlywageinvoice from "@/plugins/i18n/en/hourlywageinvoice"
import constructionreport from "@/plugins/i18n/en/constructionreport"
import violation from "@/plugins/i18n/en/violation"
import personnelplanning from "@/plugins/i18n/en/personnelplanning"
import timetracking from "@/plugins/i18n/en/timetracking"
import daysubmission from "@/plugins/i18n/en/daysubmission"
import toolbar from "@/plugins/i18n/en/toolbar"
import notification from "@/plugins/i18n/en/notification"
import file from "@/plugins/i18n/en/file"
import billing from "@/plugins/i18n/en/billing"
import onboarding from "@/plugins/i18n/en/onboarding"
import search from "@/plugins/i18n/en/search"
import dataexport from "@/plugins/i18n/en/dataexport"
import help from "@/plugins/i18n/en/help"
import releasenotes from "@/plugins/i18n/en/releasenotes"

export default {
  general,
  auth,
  nav,
  audit,
  dashboard,
  employee,
  validation,
  category,
  additionaleffort,
  material,
  machine,
  customer,
  project,
  settings,
  packet,
  userposition,
  hourlywagereport,
  hourlywageinvoice,
  constructionreport,
  violation,
  personnelplanning,
  timetracking,
  daysubmission,
  toolbar,
  billing,
  onboarding,
  notification,
  file,
  search,
  dataexport,
  help,
  releasenotes,
}
